import { http } from 'utils'
import { SET_ITEMS } from 'vx/mutations'

export default {
  namespaced: true,

  state: {
    users: []
  },

  actions: {
    async getUsers ({ commit, state }, { params = {} } = {}) {
      const response = await http.get('users', { params })

      commit(SET_ITEMS, response.data.data)

      return response
    },

    resetUsers ({ commit }) {
      commit(SET_ITEMS, [])
    }
  },

  mutations: {
    [SET_ITEMS] (state, items) {
      state.users = items
    }
  }
}
